import { useMutation, useQuery } from '@tanstack/react-query'

import type {
    AuthenticationRequest,
    SendOtpRequest,
    UserVerificationConfirmRequest,
    UserVerificationInitRequest,
} from '@leanpay/models'
import { authService, setAuthToken, timeService, userVerificationService } from '@leanpay/services'

import { CacheKey, countryCodebookId } from 'library/constants'

export const useRequestOtp = () => {
    const mutation = useMutation({
        mutationFn: (data: SendOtpRequest) => {
            return authService.requestOtp(data)
        },
    })

    return mutation
}
export const useResendOtp = () => {
    const mutation = useMutation({
        mutationFn: (data: SendOtpRequest) => {
            return authService.resendOtp(data)
        },
    })

    return mutation
}
export const useResendOtpOverInvoice = () => {
    const mutation = useMutation({
        mutationFn: (data: SendOtpRequest) => {
            return authService.resendOtpOverVoice(data)
        },
    })

    return mutation
}
export const useAuthenticate = () => {
    const mutation = useMutation({
        mutationFn: (data: AuthenticationRequest) => {
            return authService.authenticate(data)
        },
        onSuccess: (data) => {
            setAuthToken(data.idToken)
        },
    })

    return mutation
}

export const useVerificationInit = () => {
    const mutation = useMutation({
        mutationFn: (data: UserVerificationInitRequest) => {
            return userVerificationService.verificationInit(data)
        },
    })

    return mutation
}

export const useVerificationConfirm = () => {
    const mutation = useMutation({
        mutationFn: (data: UserVerificationConfirmRequest) => {
            return userVerificationService.verificationConfirm(data)
        },
    })

    return mutation
}

export const useGetAdministrativeUnits = () => {
    return useQuery({
        queryKey: [CacheKey.AdministrativeUnit],
        queryFn: () => userVerificationService.getAdministrativeUnits(countryCodebookId),
    })
}
export const useGetSessionInfo = () => {
    return useQuery({
        queryKey: [CacheKey.SessionInfo],
        queryFn: () => authService.getSessionInfo(),
        refetchOnWindowFocus: false,
        retry: false,
    })
}
export const useGetVerificationStatus = (isCompleted: boolean, correlationId?: string) => {
    return useQuery({
        queryKey: [CacheKey.VerificationStatus, correlationId],
        enabled: !isCompleted,
        queryFn: () => userVerificationService.getVerificationStatus(correlationId),
        refetchInterval: (query) => {
            // Stop refetching if verification is not found on the backend
            // TODO: Add localisation for this
            if ((query.state.error as any)?.status === 404) return false

            return 5000
        },
    })
}
export const useGetCurrentTime = () => {
    return useQuery({
        queryKey: [CacheKey.Time],
        queryFn: async () => timeService.getCurrentTime(),
    })
}
